import { render } from "./SingleCasesStudyTwo.vue?vue&type=template&id=09dda3b0&scoped=true"
import script from "./SingleCasesStudyTwo.vue?vue&type=script&lang=js"
export * from "./SingleCasesStudyTwo.vue?vue&type=script&lang=js"

import "./SingleCasesStudyTwo.vue?vue&type=style&index=0&id=09dda3b0&scoped=true&lang=css"

import exportComponent from "/Users/czh/Desktop/czh/yog_website/lada/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09dda3b0"]])

export default __exports__